<div [ngClass]="{'form-group': showLabel}">
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
    *ngIf="showLabel"
  ></wm-de-label>
  <wm-common-text
    [id]="entity.templateCode"
    [data]="{ text: modelValue | currency }"
  ></wm-common-text>
</div>
